import moment from 'moment';

export default function GREditReportInstanceCommentDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  reportsDataService,
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = handleSubmit;

  vm.IsValidControl = _IsValidControl;

  _activate();

  function _activate() {
    if (vm.reportInstanceComment.text) {
      vm.reportInstanceCommentText = vm.reportInstanceComment.text;
    }
  }

  /** ********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit() {
    const dfdSave = $q.defer();
    loaderService.showViewLoader = true;
    if ($scope.srEditReportInstanceCommentForm.$valid) {
      if (vm.reportInstanceComment.reportInstanceCommentId === 0) {
        vm.reportInstanceComment.commentDate = moment();
      }
      vm.reportInstanceComment.text = vm.reportInstanceCommentText;
      reportsDataService.saveReportInstanceNote(vm.reportInstanceComment).then((response) => {
        loaderService.showViewLoader = false;
        if (!response.data) {
          alerts.error('Error occurred while saving the ReportInstance Instance Comment.');
        } else {
          vm.reportInstanceComment = response.data;
          alerts.success('The ReportInstance Instance Comment has been saved successfully.');
          $rootScope.$broadcast('refreshReportInstanceComments',
            { reportInstanceId: vm.reportInstanceComment.reportInstanceId });
          ssDialogService.hide(ssDialogService.dialogs.reports.editReportInstanceCommentDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }

  function _IsValidControl(ctrl) {
    return ($scope.srEditReportInstanceCommentForm)
      && (($scope.srEditReportInstanceCommentForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.editReportInstanceCommentDialog);
  }
}

GREditReportInstanceCommentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
];
